export const initialState = {
  messages: {
    data: {
      count: 0,
      messages: []
    },
    unreadCount: 0,
    inProcess: false,
    isLoading: false
  },
  games: {
    gameList: [],
    recentGames: [],
    randomGames: [],
    categories: [],
    isThereIsMore: true

  },
  promotions: {
    categories: [],
    promotionsData: {}
  },
  banners: {
    data: {},
    isLoading: {}
  },
  imageSet: {
    data: {},
    isLoading: {}
  },
  user: {
    isSidebarOpen: false,
    isLoggedIn: false,
    isLoading: false,
    isUploading: false,
    isRussianLoading: false,
    firstName: null,
    lastName: null,
    email: null,
    error: "",
    documentStates: [],
    location: "",
    playerData: {
      player: {},
      accountBalance: {}
    },
    showBalanceState: true
  },
  translations: {

  },
  profile: {
    bonuses: {},
    payments: null
  },
  ui: {
    controls: {
      header: {},
      main: {},
      footer: {}
    },
    callback: false
  },
  settings: {
    logo: {},
    sportToken: {},
    clientMinAge: 0,
    cities: null,
    languages: [],
    currencies: [],
    countries: [],
    licenses: {},
    allowRegistration: null,
    demoMode: null,
    frameIntegration: { url: null },
    plugins: { cookies: false }
  },
  seo: {
    general: {
      cachingTime: 2 * 60 * 1000,
      default: {
        title: window.location.hostname,
        keywords: '',
        description: ''
      }
    },
    schema: {
      default: {
        "@context": "http://schema.org/",
        "@type": "Organization",
        name: "",
        description: "",
        image: "",
        address: {
          "@type": "PostalAddress",
          streetAddress: "",
          postalCode: "",
          addressLocality: "",
          addressRegion: ""
        },
        telephone: [],
        url: "",
        sameAs: []
      }
    },
    rules:{
      matchPaths: {},
      content: {}
    }
  },
  account: {
    verification: {
      code: 0,
      email: {
        verified: false,
        inProcess: false,
        resendVerificationCodeInProcess: false,
        error: []
      },
      mobile: {
        verified: true,
        inProcess: false,
        resendVerificationCodeInProcess: false,
        error: []
      }
    },
    responsibleGaming: {
      depositLimits: {
        data: {}
      },
      betLimits: {
        data: {}
      },
      singleBet: {
        data: {}
      },
      timeOut: {
        data: {}
      },
      selfExclusion: {
        data: {}
      },
      exclusionReasons:{},
      realityCheck: {
        data: {}
      },
      lossLimits: {
        data: {}
      },
      accessLimits: {
        data: {}
      },
      timeLimits: {
        data: {}
      }
    }
  },
  pages: {
    page: {},
    backgrounds: [],
    campaignData: {},
    campaignDataLoading: true,
  },
  notifications: {
    notificationsList: [],
    alert: {}
  },
  lobbies: {
    livecasino: {
      groups: [],
      categories: [],
      lobby: {},
      products: [],
      categoryCounts: [],
      mostLiked: [],
      isThereIsMore: true
    }
    ,
    'casino-lobby': {
      groups: [],
      categories: [],
      lobby: {},
      products: [],
      categoryCounts: [],
      mostLiked: [],
      isThereIsMore: true
    },
    casino: {
      groups: [],
      categories: [],
      lobby: {},
      products: [],
      categoryCounts: [],
      mostLiked: [],
      isThereIsMore: true
    },
    'tvgames-lobby': {
      groups: [],
      categories: [],
      lobby: {},
      products: [],
      categoryCounts: [],
      mostLiked: [],
      isThereIsMore: true
    },
    'virtualsport-lobby': {
      groups: [],
      categories: [],
      lobby: {},
      products: [],
      categoryCounts: [],
      mostLiked: [],
      isThereIsMore: true
    },
    'fastgames-lobby': {
      groups: [],
      categories: [],
      lobby: {},
      products: [],
      categoryCounts: [],
      mostLiked: [],
      isThereIsMore: true
    },
    'single-game': {}
  },
  tournaments: {
    tournamentsList: [],
    tournament: {}
  },
  widgets: [

  ],
  popup: {

  },
  stories: {
    data: []
  },
  promoTool: {
    data: null,
    winPrize:{},
    winnings:{},
    isWinningsLoading:false,
    isWinPrizeLoading:false,
    isLoading: true,
    settings:{},
    exchangeCenter:{
      data:{},
      isLoading:false
    },
  },
};

export default initialState;